import { UserDirectoryContext } from "hhn-commons";
import { useContext } from "react";
import ChatListItem, { ChatListItemProps } from "../ChatListItem";
import { IPrivateChatData } from "@home-health-notify/domain";

interface PrivateChatListItemProps {
  chatData: IPrivateChatData;
  isSelected: boolean;
}

function PrivateChatListItem({
  chatData,
  isSelected,
}: PrivateChatListItemProps) {
  const { userDirectory } = useContext(UserDirectoryContext);
  const userInfo = userDirectory.getUserInfo(chatData.from);
  const chatItemProps: ChatListItemProps = {
    chatData,
    isSelected: isSelected,
    avatarText: userInfo.name,
    title: userInfo.title,
    image: userInfo.image,
    groupType: userInfo.groupType,
  };
  return <ChatListItem key={chatData.from} {...chatItemProps} />;
}

export default PrivateChatListItem;
